var map = {
	"./azxy10_bg.png": "42d4",
	"./azxy20_bg.png": "8e8c",
	"./azxy5_bg.png": "4aa3",
	"./azxy8_bg.png": "3af8",
	"./cannon20_bg.png": "9ddd",
	"./cannon20ex_bg.png": "a84a",
	"./gamma3_bg.png": "13a1",
	"./gamma3ex_bg.png": "8354",
	"./infinity8_bg.png": "adab",
	"./infinity8ex_bg.png": "c6db",
	"./jisukuai3_bg.png": "df04",
	"./jisukuaile_bg.png": "6fce",
	"./jisusaiche_bg.png": "d2d9",
	"./jisushishi_bg.png": "f460",
	"./kl8lhc_bg.png": "2f48",
	"./lucky5_bg.png": "db53",
	"./lucky5ex_bg.png": "b62e",
	"./lucky7daily_bg.png": "122e",
	"./megamillions_bg.png": "4514",
	"./penta5_bg.png": "66ba",
	"./penta5classic_bg.png": "e727",
	"./penta5ex_bg.png": "890e",
	"./pl3_bg.png": "6f40",
	"./pl5_bg.png": "3592",
	"./pl5daily_bg.png": "921c",
	"./powerball_bg.png": "ac26",
	"./qxc_bg.png": "818b",
	"./rolling10_bg.png": "085c",
	"./rolling10ex_bg.png": "c954",
	"./sgplhc_bg.png": "b4e8",
	"./surfing10classic_bg.png": "439f",
	"./xglhc_bg.png": "0eb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef348";